'use client';

import GroupsRoundedIcon from '@mui/icons-material/GroupsRounded';
import { Avatar } from '@mui/material';
import { initials, isHouseEmail } from '@/lib/inbox/display';

// Bump when the logo response format changes so browsers drop their cached copies.
const LOGO_VERSION = 2;

type Props = {
  name: string;
  email?: string;
  size: number;
  bg: string;
  fg: string;
  logo?: boolean;
  group?: boolean;
  picture?: string;
};

export default function SenderAvatar({ name, email, size, bg, fg, logo = true, group = false, picture }: Props) {
  const src = picture || (isHouseEmail(email) ? '/timmy-icon.png' : logo && email?.includes('@') ? `/api/inbox/logo?v=${LOGO_VERSION}&email=${encodeURIComponent(email)}` : undefined);
  return (
    <Avatar
      src={src}
      alt=""
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        fontSize: size >= 36 ? '0.8125rem' : '0.75rem',
        fontWeight: 600,
        letterSpacing: '0.02em',
        bgcolor: bg,
        color: fg,
        '& .MuiAvatar-img': { objectFit: 'cover', bgcolor: '#fff' },
        '&:has(.MuiAvatar-img)::after': {
          content: '""',
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          boxShadow: 'inset 0 0 0 1px rgba(20,20,18,0.08)',
          pointerEvents: 'none',
        },
      }}
    >
      {group ? <GroupsRoundedIcon aria-hidden sx={{ fontSize: Math.round(size * 0.55) }} /> : initials(name)}
    </Avatar>
  );
}
